import { NumberOrNullOrND } from 'src/types/wallet';

export function calculateFicPlPercentage(
  marketValue: NumberOrNullOrND | undefined,
  netEquity: NumberOrNullOrND | undefined,
): number | 'N/D' {
  if (
    typeof marketValue !== 'number' ||
    typeof netEquity !== 'number' ||
    !Number.isFinite(marketValue) ||
    !Number.isFinite(netEquity) ||
    netEquity === 0
  ) {
    return 'N/D';
  }

  const percentage = (marketValue / netEquity) * 100;
  return Number.isFinite(percentage) ? percentage : 'N/D';
}

export function resolveFicPlPercentage(
  plPercentage: NumberOrNullOrND | undefined,
  marketValue: NumberOrNullOrND | undefined,
  netEquity: NumberOrNullOrND | undefined,
): number | 'N/D' {
  if (plPercentage == null) {
    return calculateFicPlPercentage(marketValue, netEquity);
  }

  if (typeof plPercentage === 'number' && Number.isFinite(plPercentage)) {
    return plPercentage;
  }

  return 'N/D';
}

export function formatFicPlPercentage(value: number | 'N/D'): string {
  if (value === 'N/D') return 'N/D';

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatFicMarketValueInMillions(
  value: NumberOrNullOrND | undefined,
): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 'N/D';

  return `R$ ${(value / 1_000_000).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} mi`;
}
